// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_93-0";